import React from "react";
import "./error-message.css";

function ErrorMessage({
  title = "Что-то пошло не так",
  message = "Не удалось выполнить запрос. Попробуйте снова.",
  actionLabel = null,
  onAction = null,
  className = "",
}) {
  const rootClassName = ["error-message", className].filter(Boolean).join(" ");

  return (
    <div className={rootClassName} role="alert" aria-live="polite">
      <h3 className="error-message__title">{title}</h3>
      <p className="error-message__text">{message}</p>
      {actionLabel && typeof onAction === "function" ? (
        <button
          className="error-message__button"
          type="button"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}

export default ErrorMessage;
